import { 
    REFERRAL_FILE_GET_REQUEST, REFERRAL_FILE_GET_SUCCESS, REFERRAL_FILE_GET_ERROR, 
    REFERRAL_FILE_GET_BY_KEY_REQUEST, REFERRAL_FILE_GET_BY_KEY_SUCCESS, REFERRAL_FILE_GET_BY_KEY_ERROR, 
    REFERRAL_FILE_ADD_REQUEST, REFERRAL_FILE_ADD_SUCCESS, REFERRAL_FILE_ADD_ERROR, 
    REFERRAL_FILE_EDIT_REQUEST, REFERRAL_FILE_EDIT_SUCCESS, REFERRAL_FILE_EDIT_ERROR, 
    REFERRAL_FILE_DELETE_REQUEST, REFERRAL_FILE_DELETE_SUCCESS, REFERRAL_FILE_DELETE_ERROR
} from "../constants/referralFileConstants";

const initialState = {
    referralFiles: [],
    referralFile: {},
    loading: false,
    success: null,
    error: null,
    referralFileRequestedCount: 0,
};

export const referralFileReducer = (state = initialState, action) => {
    switch (action.type)     {
        case REFERRAL_FILE_GET_REQUEST:
            return {
                ...state,
                referralFileRequestedCount: ++state.referralFileRequestedCount,
                loading: true,
            };
        case REFERRAL_FILE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                referralFiles: action.payload,
                success: true,
            };
        case REFERRAL_FILE_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_FILE_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_FILE_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                referralFile: action.payload,
                success: true,
            };
        case REFERRAL_FILE_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_FILE_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_FILE_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REFERRAL_FILE_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_FILE_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_FILE_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REFERRAL_FILE_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_FILE_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_FILE_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REFERRAL_FILE_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
